import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { Stories } from '../../store/slices';
import { useStyles } from './styles';

interface AuthorsTableProps {
    authors: any[];
    paging: { page: number; perPage: number; total: number };
    pagingUpdate: (params: any) => void;
}

/** Authors list; "Stories" opens the stories list filtered to that author. */
export default function AuthorsTable({ authors, paging, pagingUpdate }: AuthorsTableProps) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const handleChangePage = (_event: unknown, newPage: number) => {
        pagingUpdate({ page: newPage + 1, perPage: paging.perPage });
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        pagingUpdate({ page: 1, perPage: +event.target.value });
    };

    return (
        <>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="Authors">
                    <TableHead>
                        <TableRow>
                            <TableCell>Author</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell align="right">Stories</TableCell>
                            <TableCell align="right">Rewards</TableCell>
                            <TableCell>Shopify customer</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {authors.map((author) => (
                            <TableRow key={author.authorId} hover>
                                <TableCell>
                                    <div className={classes.name}>{author.firstName || '—'}</div>
                                    <div className={classes.mono} style={{ fontSize: 12, opacity: 0.8 }}>#{author.authorId}</div>
                                </TableCell>
                                <TableCell className={classes.email}>{author.email || '—'}</TableCell>
                                <TableCell className={classes.numeric}>
                                    <Link
                                        to={`/stories/?authorId=${author.authorId}`}
                                        className={classes.countLink}
                                        onClick={() => dispatch(Stories.clearFilters())}
                                        title="Open this author's stories"
                                    >
                                        {author.storyCount ?? 0}
                                    </Link>
                                </TableCell>
                                <TableCell className={classes.numeric}>{author.rewards ?? '—'}</TableCell>
                                <TableCell className={classes.mono}>{author.shopifyId || '—'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 15, 25]}
                component="div"
                count={paging.total}
                rowsPerPage={paging.perPage}
                page={Math.max(0, paging.page - 1)}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );
}
